import Tab from './Tab'
import TabItem from './TabItem'

export {
  Tab,
  TabItem
}



// WEBPACK FOOTER //
// ./src/components/Tab/index.js